import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components-new/table';
import { Actor } from '@/types/actor';
import { formatTimestamp } from '@/utils/date-time-functions';

export type ChangeLog = {
  id: number;
  description: string;
  occurredAt: string;
  initiatedBy: Actor;
};

type ChangeLogTableProps = {
  changeLogs: ChangeLog[]
}

export const ChangeLogTable = ({ changeLogs }: ChangeLogTableProps) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>Description</TableHeader>
          <TableHeader>Initiated By</TableHeader>
          <TableHeader>Occurred At</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {changeLogs.map((log) => (
          <TableRow key={log.id}>
            <TableCell>{log.description}</TableCell>
            <TableCell>{log.initiatedBy.name}</TableCell>
            <TableCell>{formatTimestamp(log.occurredAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
